import { render, staticRenderFns } from "./LockAlert.vue?vue&type=template&id=0df388b2&"
import script from "./LockAlert.vue?vue&type=script&lang=js&"
export * from "./LockAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports